export default {
      id: "telegram-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "svgsprite.svg#telegram",
      toString: function () {
        return this.url;
      }
    }